import api from './client';
import type { Workspace } from '../types';

export const fetchWorkspaces = async (): Promise<Workspace[]> => {
  const { data } = await api.get<Workspace[]>('/workspaces');
  return data;
};

export interface CreateWorkspacePayload {
  name: string;
}

export const createWorkspace = async (
  payload: CreateWorkspacePayload,
): Promise<Workspace> => {
  const { data } = await api.post<Workspace>('/workspaces', payload);
  return data;
};

export interface UpdateWorkspacePayload {
  name?: string;
  status?: Workspace['status'];
}

export const updateWorkspace = async (
  id: string,
  payload: UpdateWorkspacePayload,
): Promise<Workspace> => {
  const { data } = await api.patch<Workspace>(`/workspaces/${id}`, payload);
  return data;
};

